// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
}
.modal-footer {
  padding: 2px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/dialogs/email-monthly-accounting-report/email-monthly-accounting-report.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;AADF;AAGA;EACE,aAAA;AADF;AAIA;EACE,yBAAA;EACA,uBAAA;AAFF;AAAA;EAKI,0BAAA;EACA,gBAAA;AAFJ;AAJA;EASI,UAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;AAMA;EACE,uBAAA;AAJF","sourcesContent":["@import (reference) url('../../../../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n  margin: 8px 0;\n}\n\n.modal-header{\n  background-color: #0f1a35;\n  color: white !important;\n\n  .modal-title{\n    font-size: 20px !important;\n    font-weight: 600;\n  };\n  .close{\n    color: red;\n    text-shadow: none;\n    opacity: 1;\n    font-size: 26px;\n    padding: 0 !important;\n    margin : 0 !important;\n    box-shadow: none;\n    background: transparent;\n  }\n}\n\n.modal-footer{\n  padding: 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
